// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__8cXjB","label":"Radio_label__16SyZ","checkMark":"Radio_checkMark__14-bv","disabled":"Radio_disabled__1ae5l"};